<template>
  <div id="adminschools">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col>
          <Schools />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import Schools from "@/components/admin-components/global/Schools.vue";
export default {
  name: "AdminSchools",
  components: { Schools },
  data: () => ({}),
};
</script>